import React from 'react';

interface IconAngleUpProps {
    iconClasses?: string;
}

const IconAngleUp: React.FC<IconAngleUpProps> = ({ iconClasses }) => {
    return (
        <svg
            width="25"
            height="13"
            viewBox="0 0 25 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-angle-up ${iconClasses ?? ''}`}
        >
            <path d="M22.5 13L25 10.8334L12.5001 0L0 10.8334L2.49999 13L12.5001 4.33329L22.5 13Z" fill="currentColor" />
        </svg>
    );
};

export default IconAngleUp;
